<template>
    <div class="d-flex flex-row flex-nowrap gap-3">
        <input
            type="file"
            @change="change"
            :accept="accept"
        />
        <span>{{ value?.name }}</span>
    </div>
</template>
<script setup lang="ts">
const value = defineModel<File | null>({ required: true });

const change = (e: Event) => {
    if (!(e.target instanceof HTMLInputElement)) {
        throw new Error('You can actually get here, this is just a guard');
    }
    const target = e.target;
    if (target.files && target.files.length > 0) {
        value.value = target.files[0];
    } else {
        value.value = null;
    }
};

const props = defineProps<{
    accept?: string;
}>();
</script>
